import {initWebComponent} from "@/helpers/web-component-helper";
import {setInfoValue} from "@/helpers/info-overview-helper";

const template = document.createElement('template');

export class FormTextareaComponent extends HTMLElement {
    constructor() {
        super();
        const name = this.getAttribute('data-name')
        const placeholder = this.getAttribute('data-placeholder')
        const attributeID = this.getAttribute('data-attribute-id')

        template.innerHTML = `
<h2 class="text-primary">` + name + `</h2>
<textarea 
    class="form-control" 
    placeholder="` + placeholder + `"
    rows="15" 
    name="toelichting">
</textarea>`

        initWebComponent(this, template)

        this.addEventListener('change', (element) => {
            const innerHtml = element.target.value
            setInfoValue(attributeID, innerHtml)
        })
    }
}
